import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setItems(r.data)); }, []);
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Audit log</h1>
      <p className="text-slate-600 mt-1">Every important action, by AI or humans.</p>
      <div className="mt-6 bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {items.length === 0 ? (
          <div className="p-10 text-center text-slate-500">No activity yet.</div>
        ) : (
          <div className="overflow-x-auto"><table className="w-full text-sm min-w-[560px]" data-testid="audit-table">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr><th className="text-left px-6 py-3">When</th><th className="text-left px-6 py-3">Actor</th><th className="text-left px-6 py-3">Action</th><th className="text-left px-6 py-3">Entity</th></tr>
            </thead>
            <tbody>
              {items.map(a => (
                <tr key={a.id} className="border-t border-slate-100">
                  <td className="px-6 py-3 text-slate-500">{new Date(a.at).toLocaleString()}</td>
                  <td className="px-6 py-3"><span className={`text-xs px-2 py-1 rounded-full ${a.actor === "ai" ? "bg-blue-50 text-blue-700" : "bg-slate-100 text-slate-700"}`}>{a.actor}</span></td>
                  <td className="px-6 py-3 font-mono text-xs">{a.action}</td>
                  <td className="px-6 py-3 text-slate-500">{a.entity} {a.entity_id?.slice(0, 8)}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
